// P/L 画面用のフォーマッタ群。design/STOQ_dashboard.dc.html の class Component 内
// yen/man/pct/num/roas/delta/pc を TypeScript の純関数として移植したもの。

/** 円表示。負数は '−¥1,234' で赤(#b23a2e)。色付けは呼び出し側で profitColor() を使う。 */
export function yen(n: number): string {
  const sign = n < 0 ? "−¥" : "¥";
  return sign + Math.round(Math.abs(n)).toLocaleString("ja-JP");
}

/** 万円単位（チャートのy軸・ヒートマップ・広告経由売上など）。1万未満はそのまま円数値。 */
export function man(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1e4) {
    return (n / 1e4).toFixed(abs >= 1e6 ? 0 : 1) + "万";
  }
  return Math.round(n).toLocaleString("ja-JP");
}

/** パーセント表示（小数第1位）。null/NaN/Infinity は '—'。 */
export function pct(x: number | null | undefined): string {
  return x != null && isFinite(x) ? (x * 100).toFixed(1) + "%" : "—";
}

export function num(n: number): string {
  return Math.round(n).toLocaleString("ja-JP");
}

/** ROAS（倍率）表示。小数第2位。 */
export function roasFmt(v: number | null | undefined): string {
  return v != null && isFinite(v) ? v.toFixed(2) : "—";
}

/** 貢献利益などの色（赤字は#b23a2e、それ以外は本文色）。 */
export function profitColor(v: number): string {
  return v < 0 ? "#b23a2e" : "#1f2523";
}

export interface Delta {
  text: string;
  color: string;
}

/**
 * 前期比デルタ。
 * @param opts.pt trueなら %pt 表示（利益率など）。false/省略なら相対%表示。
 * @param opts.invert trueなら増加が赤・減少が緑（広告費・広告費率など「コスト系」指標）。
 */
export function delta(
  cur: number,
  prev: number | null | undefined,
  opts: { pt?: boolean; invert?: boolean } = {}
): Delta {
  if (prev == null || !isFinite(prev) || (!opts.pt && prev === 0)) {
    return { text: "比較データなし", color: "#6a6f6b" };
  }
  const d = opts.pt ? (cur - prev) * 100 : ((cur - prev) / Math.abs(prev)) * 100;
  let good = d >= 0;
  if (opts.invert) good = !good;
  return {
    text: (d >= 0 ? "+" : "−") + Math.abs(d).toFixed(1) + (opts.pt ? "pt" : "%") + " 前期比",
    color: good ? "#2e7d4f" : "#b23a2e",
  };
}
